import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { SnackBarContext } from '../../Context/SnackBarContextProvider';
import { useRevokeQuizAssignmentMutation } from '../../services/SkillsManagement';
import { REVOKE_QUIZ_ASSIGNMENT } from '../../Reducers/Actions';
import BlockIcon from '@mui/icons-material/Block';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import MuiDialog from '../../SystemDesign/MuiDialog';

const RevokeAssignment = ({ row }) => {
  const dispatch = useDispatch();
  const { setInfoAlert, setOpenSnackBar } = useContext(SnackBarContext);
  const [revokeAssignment, { isLoading }] = useRevokeQuizAssignmentMutation();

  const assignment = row?.original || {};
  const id = assignment.assignmentId ?? assignment.id;
  if (!id) return null;

  const handleConfirmRevoke = async () => {
    try {
      const result = await revokeAssignment({ assignmentId: Number(id) }).unwrap();
      const updated = result?.data || result;

      if (updated && (updated.assignmentId || updated.id)) {
        dispatch({ type: REVOKE_QUIZ_ASSIGNMENT, payload: updated });
      } else {
        dispatch({ type: REVOKE_QUIZ_ASSIGNMENT, assignmentId: Number(id) });
      }

      setInfoAlert({ severity: 'success', message: 'Assignment revoked successfully.' });
      setOpenSnackBar(true);
      // Notify assignment lists to refetch immediately
      try { window.dispatchEvent(new CustomEvent('quiz-assignments:changed')); } catch {}
      return true;
    } catch (error) {
      setInfoAlert({
        severity: 'error',
        message: error?.data?.message || error?.message || 'Failed to revoke assignment.',
      });
      setOpenSnackBar(true);
      return false;
    }
  };

  const triggerButton = (
    <MenuItem>
      <ListItemIcon>
        <DoNotDisturbOnIcon fontSize="small" color="warning" />
      </ListItemIcon>
      <ListItemText>Revoke</ListItemText>
    </MenuItem>
  );

  const dialogContent = (
    <div>
      <p>Are you sure you want to revoke assignment {id}?</p>
      <p>The assignee will not be able to proceed further.</p>
    </div>
  );

  return (
    <MuiDialog
      icon={<BlockIcon />}
      triggerButton={triggerButton}
      title="Revoke Assignment"
      subtitle={`You are about to revoke assignment ${id}`}
      content={dialogContent}
      maxWidth="xs"
      existAction={true}
      actionTitle="Revoke"
      actionFunction={handleConfirmRevoke}
      isLoading={isLoading}
    />
  );
};

RevokeAssignment.menuIcon = <BlockIcon fontSize="small" />;
RevokeAssignment.menuLabel = 'Revoke';

export default RevokeAssignment;